import React, { memo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";

const RegistrationModal = memo(({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center px-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative w-full max-w-4xl bg-background glass rounded-3xl overflow-hidden gold-border shadow-2xl z-10"
          >
            <button
              onClick={onClose}
              className="absolute top-6 right-6 p-2 rounded-full bg-white/5 text-text-secondary hover:text-gold transition-colors z-20"
              aria-label="Close modal"
            >
              <Sparkles className="w-6 h-6 rotate-45" />
            </button>
            
            <div className="h-[80vh] w-full">
              <iframe
                src="https://link.msgsndr.com/widget/form/makGWar6Bz"
                style={{ width: '100%', height: '100%', border: 'none' }}
                id="ghl-form-frame"
                title="Registration Form"
                loading="lazy"
              />
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
});

RegistrationModal.displayName = "RegistrationModal";

export default RegistrationModal;
